import { makeAutoObservable } from "mobx";
import { RDate } from "../../core";
import { ParameterSet } from "../ParameterSet";
export class CreatorRootScope {
    constructor(params) {
        this.restaurant = params.restaurant;
        this.now = RDate.now(params.restaurant.timezone);
        makeAutoObservable(this);
    }
    get parameterSet() {
        return ParameterSet.empty();
    }
    get currentFulfillmentTimes() {
        // TODO Update time automatically maybe?
        return this.restaurant.currentFulfillmentTimes(this.now);
    }
    get preorderTime() {
        return null;
    }
}
